<template>
<div class="chapter">
<div class="inner_page">
<p class="p4">Für Jeannie, meine Beta-Leserin und gute Freundin, die mich auf jedes Komma und falsch platzierte Wort hinweist. Für die Mitglieder meiner kleinen Gruppe von Kritikern, die mir mit ihrem ehrlichen und liebevollen Feedback geholfen haben, diese Geschichte zum Leben zu erwecken. Und für alle meine Leser auf LiveJournal und anderen Seiten, die mich seit Jahren beim Schreiben unterstützen und mir den Mut gegeben haben, ein Manuskript einzureichen.</p>
<p class="p5"> </p>
<p class="p5">– Mickie, April 2009</p>
<p class="p5"> </p>
<p class="p5">Ich bedanke mich bei allen Lesern, die die erste Version von <span class="t4">Horizons</span> gekauft haben. Ihr habt mich inspiriert, dieses Universum in Form von zwei Spin-off Romanen, <span class="t4">Taste</span> und <span class="t4">Daddio</span>, weiterzuspinnen. Die erste Version von <span class="t4">Horizons</span> enthielt einige Fehler in der Football-Zeitleiste (hundertprozentig mein Fehler!), und wir haben uns Mühe gegeben, sie alle zu verbessern. Dafür möchte ich mich bei Lynn West, Dreamspinners unerschrockener Chefredakteurin, bedanken, die mich bei diesem Projekt unterstützt und mir ihr Wissen über College Football großzügig zur Verfügung gestellt hat. Ich möchte mich auch bei David, meinem Zeileneditor, bedanken, der mir geholfen, hat, dass diese zweite Version flüssiger zu lesen ist, ohne das Herz und die Seele der Originalgeschichte zu verfälschen.</p>
<p class="p5"> </p>
<p class="p5">– Mickie, Juli 2013</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?bfb5132e